<template>
    <div class="container notification-sender-container">
      <!-- ✨ --- بداية التعديل: استخدام تصميم العمودين --- ✨ -->
      <el-row :gutter="20">
        
        <!-- Main Content Column (Filters & Table) -->
        <el-col :span="16">
          <el-card shadow="hover">
            <template #header>
              <div class="card-header">
                <h2>قائمة أولياء الأمور</h2>
              </div>
            </template>
  
            <!-- Filters Section -->
            <div class="filter-section">
              <el-input v-model="filters.search" placeholder="ابحث عن ولي الأمر بالاسم..." @input="handleFilterChange" clearable style="width: 250px;" />
              <el-select v-model="filters.class_id" placeholder="فلترة حسب الفصل" clearable @change="onClassChange" style="width: 200px;">
                <el-option v-for="cls in metaData.classes" :key="cls.id" :label="cls.name" :value="cls.id" />
              </el-select>
              <el-select v-model="filters.section_id" placeholder="فلترة حسب الشعبة" clearable @change="handleFilterChange" style="width: 200px;" :disabled="!filters.class_id">
                <el-option v-for="sec in metaData.sections" :key="sec.id" :label="sec.name" :value="sec.id" />
              </el-select>
              <el-select v-model="filters.teacher_id" placeholder="فلترة حسب المعلم" clearable @change="handleFilterChange" style="width: 200px;">
                <el-option v-for="teacher in metaData.teachers" :key="teacher.id" :label="teacher.name" :value="teacher.id" />
              </el-select>
              <el-select v-model="pagination.per_page" placeholder="عدد السجلات" @change="handleFilterChange" style="width: 150px;">
                <el-option label="15 سجل" :value="15" />
                <el-option label="30 سجل" :value="30" />
                <el-option label="50 سجل" :value="50" />
                <el-option label="100 سجل" :value="100" />
              </el-select>
            </div>
  
            <!-- Parents Table -->
            <el-table :data="parents" v-loading="loading" border style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55" />
              <el-table-column prop="name" label="اسم ولي الأمر" width="250" />
              <el-table-column label="الأبناء المسجلون">
                <template #default="{ row }">
                  <div v-if="row.parent_details && row.parent_details.students.length > 0">
                    <div v-for="student in row.parent_details.students" :key="student.id" class="student-info">
                      <el-icon><User /></el-icon>
                      <span><strong>{{ student.name }}</strong> - ({{ student.class.name }} / {{ student.section.name }})</span>
                    </div>
                  </div>
                  <span v-else>لا يوجد أبناء مسجلون</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-container">
              <el-pagination v-if="pagination.total > 0" @current-change="handlePageChange" :current-page="pagination.current_page" :page-size="pagination.per_page" :total="pagination.total" layout="total, prev, pager, next" background />
            </div>
          </el-card>
        </el-col>
  
        <!-- Sticky Form Column -->
        <el-col :span="8">
          <div class="sticky-form">
              <el-card shadow="hover">
                  <template #header>
                      <h3>محتوى الإشعار</h3>
                  </template>
                  <p>سيتم إرسال الإشعار إلى <strong>{{ selectedParents.length }}</strong> ولي أمر محدد.</p>
                  <el-form :model="form" label-position="top" style="margin-top: 20px;">
                  <el-form-item label="عنوان الإشعار">
                      <el-input v-model="form.title" />
                  </el-form-item>
                  <el-form-item label="نص الإشعار">
                      <el-input v-model="form.body" type="textarea" :rows="4" />
                  </el-form-item>
                  <el-form-item label="صورة (اختياري)">
                      <el-upload
                          action="#"
                          :auto-upload="false"
                          :on-change="handleImageChange"
                          :limit="1"
                          list-type="picture-card"
                      >
                          <el-icon><Plus /></el-icon>
                      </el-upload>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" @click="sendNotifications" :loading="sending" :disabled="selectedParents.length === 0 || !form.title || !form.body" style="width: 100%;">
                      إرسال الإشعار
                      </el-button>
                  </el-form-item>
                  </el-form>
              </el-card>
          </div>
        </el-col>
  
      </el-row>
      <!-- --- نهاية التعديل --- ✨ -->
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus';
  import { User, Plus } from '@element-plus/icons-vue';
  import debounce from 'lodash/debounce';
  
  export default {
    name: 'NotificationSender',
    components: { User, Plus },
    data() {
      return {
        api: null,
        parents: [],
        loading: false,
        sending: false,
        filters: {
          search: '',
          class_id: null,
          section_id: null,
          teacher_id: null,
        },
        metaData: {
          classes: [],
          sections: [],
          teachers: [],
        },
        pagination: {
          current_page: 1,
          per_page: 15,
          total: 0,
        },
        selectedParents: [],
        form: {
          title: '',
          body: '',
          image: null,
        },
      };
    },
    created() {
      this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
      this.api.interceptors.request.use(config => {
        const token = localStorage.getItem('access_token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
      });
      this.fetchParentList();
      this.fetchFilterMetaData();
      this.handleFilterChange = debounce(this.handleFilterChange, 500);
    },
    methods: {
      async fetchParentList() {
        this.loading = true;
        try {
          const params = {
            page: this.pagination.current_page,
            per_page: this.pagination.per_page,
            ...this.filters,
          };
          const response = await this.api.get('/targeted-notifications/parents', { params });
          this.parents = response.data.data;
          this.pagination.total = response.data.total;
          this.pagination.current_page = response.data.current_page;
        } catch (error) {
          ElMessage.error('فشل في جلب قائمة أولياء الأمور.');
        } finally {
          this.loading = false;
        }
      },
      async fetchFilterMetaData() {
        try {
          const [classesRes, teachersRes] = await Promise.all([
            this.api.get('/classes'),
            this.api.get('/teachers'),
          ]);
          this.metaData.classes = classesRes.data;
          this.metaData.teachers = teachersRes.data;
        } catch (error) {
          ElMessage.error('فشل في جلب بيانات الفلاتر.');
        }
      },
      async fetchSectionsForClass(classId) {
          try {
              const response = await this.api.get(`/classes/${classId}/sections-to`);
              this.metaData.sections = response.data;
          } catch (error) {
              ElMessage.error('فشل في جلب الشعب الخاصة بالفصل.');
              this.metaData.sections = [];
          }
      },
      onClassChange(classId) {
          this.filters.section_id = null;
          this.metaData.sections = [];
          if (classId) {
              this.fetchSectionsForClass(classId);
          }
          this.handleFilterChange();
      },
      handleFilterChange() {
        this.pagination.current_page = 1;
        this.fetchParentList();
      },
      handlePageChange(newPage) {
        this.pagination.current_page = newPage;
        this.fetchParentList();
      },
      handleSelectionChange(selection) {
        this.selectedParents = selection.map(item => item.id);
      },
      handleImageChange(file) {
          this.form.image = file.raw;
      },
      async sendNotifications() {
        if (this.selectedParents.length === 0) {
          ElMessage.warning('يرجى تحديد ولي أمر واحد على الأقل.');
          return;
        }
  
        this.sending = true;
        const formData = new FormData();
        formData.append('title', this.form.title);
        formData.append('body', this.form.body);
        if (this.form.image) {
          formData.append('image', this.form.image);
        }
        this.selectedParents.forEach(id => {
          formData.append('user_ids[]', id);
        });
  
        try {
          const response = await this.api.post('/targeted-notifications/send', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          ElMessage.success(response.data.message);
          this.form.title = '';
          this.form.body = '';
          this.form.image = null;
        } catch (error) {
          const errorMsg = error.response?.data?.message || 'فشل في إرسال الإشعارات.';
          ElMessage.error(errorMsg);
        } finally {
          this.sending = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .notification-sender-container {
    padding: 20px;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filter-section {
    margin-bottom: 20px;
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
  }
  .student-info {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 5px;
  }
  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  /* ✨ --- بداية الإضافة: تنسيق للعمود الثابت --- ✨ */
  .sticky-form {
      position: sticky;
      top: 20px;
  }
  /* --- نهاية الإضافة --- ✨ */
  </style>
  
  